import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Today from "./pages/Today";
import Upcoming from "./pages/Upcoming";
import Chat from "./pages/Chat";
import Notifications from "./pages/Notifications";
import Profile from "./pages/Profile";
import Subscribe from "./pages/Subscribe";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminSessions from "./pages/admin/Sessions";
import AdminSubscribers from "./pages/admin/Subscribers";
import AdminChat from "./pages/admin/Chat";
import PaymentAnalytics from "./pages/admin/PaymentAnalytics";
import Testing from "./pages/admin/Testing";
import AdminPromoVideos from "./pages/admin/PromoVideos";
import PromoVideos from "./pages/PromoVideos";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <LanguageProvider>
        <ErrorBoundary>
          <Toaster />
          <Sonner />
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/today" element={<Today />} />
            <Route path="/promo-videos" element={<PromoVideos />} />
            <Route path="/upcoming" element={<Upcoming />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/sessions" element={<AdminSessions />} />
            <Route path="/admin/subscribers" element={<AdminSubscribers />} />
            <Route path="/admin/chat" element={<AdminChat />} />
            <Route path="/admin/payments" element={<PaymentAnalytics />} />
            <Route path="/admin/promo-videos" element={<AdminPromoVideos />} />
            <Route path="/admin/testing" element={<Testing />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      </LanguageProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
